<template>
  <div class='container'>
    <p class="ins_title">电子标签蓝牙开启方式</p>
    <div class="ins_introduce">
      <p class="ins_introduce_item"><span>埃特斯：两次快速插拔ETC卡，开启蓝牙，成功开启后屏幕显示“蓝牙已开”。</span></p>
      <p class="ins_introduce_item"><span>金溢：两次快速插拔ETC卡，开启蓝牙，成功开启后屏幕显示“蓝牙已开”。</span></p>
      <p class="ins_introduce_item"><span>千方：将电子标签安装固定在合适位置后，两次快速插拔，两次快速插拔ETC卡，开启蓝牙，成功开启后屏幕左上角绿色指示灯点亮。</span></p>
      <p class="ins_introduce_item"><span>聚利：将电子标签安装固定在合适位置后，两次快速插拔，同时按下电子标签右下方按钮，开启蓝牙，成功开启后屏幕显示“蓝牙已开启”同时OBU左上角红色指示灯闪烁。</span></p>
      <p class="ins_introduce_item"><span>成谷：两次快速插拔ETC卡，开启蓝牙，成功开启后屏幕显示“蓝牙已开”同时屏幕左侧绿色指示灯闪烁。</span></p>
      <div class="thousand">
        <p>万集：</p>
        <p class="ins_introduce_item"><span>方式1：</span><span>两次快速插拔ETC卡，开启蓝牙，成功开启后屏幕显示“蓝牙开启”，同时屏幕左侧蓝色指示灯闪烁。</span></p>
        <p class="ins_introduce_item"><span>方式2：</span><span>将ETC卡插入OBU设备，点击OBU上方按钮，开启蓝牙，成功开启后屏幕显示“蓝牙开启”，同时屏幕左侧蓝色指示灯闪烁。</span></p>
      </div>
      <p class="">电子标签开启时间约为2分钟，请在开启时间内完成激活。</p>
    </div>
  </div>
</template>

<script>
export default {

}

</script>
<style scoped lang='less'>
.container {
  height: 100%;
  width: 100%;
  background-color: #fff;
  text-align: left;
  padding: 2rem 1.5rem 2rem;
  box-sizing: border-box;
  font-size: 0.9rem;
  line-height: 1.2rem;
  .ins_title {
    font-weight: 600;
  }
  .ins_introduce {
    margin-top: 2rem;
  }
  .ins_introduce_item {
    color: #000;
    margin-bottom: 1rem;
  }
  .thousand {
    margin-bottom: 1rem;
    margin-bottom: 2rem;
  }
}
</style>